module.exports = {
  NOT_VERIFIED: 1,
  SKIP: 2,
  VERIFIED: 3,
};
